import { FormProperty } from './formProperty';
import { PropertyTypes } from '../enum/propertyTypes';
import { EventEmitter } from '@angular/core';
import { GSSimpleListControl } from '../../controls/gsControls';
import { format } from 'url';

export class FormSimpleListProperty extends FormProperty {
  type = PropertyTypes.Number;
  changed = new EventEmitter<any>();
  keydown = new EventEmitter<any>();
  onpaste = new EventEmitter<any>();
  mode: string;
  component = GSSimpleListControl;
  maxLength: number;
  showButtons: boolean;

  constructor(
    name: string,
    label: string,
    row?: number,
    column?: number,
    rowspan?: number,
    columnspan?: number,
    validate?: boolean,
    validationRegExp?: RegExp,
    align?,
    maxLength?: number
  ) {
    super(
      name,
      label,
      row,
      column,
      rowspan,
      columnspan,
      validate,
      validationRegExp,
      align
    );
    this.maxLength = maxLength;
  }
}
